<div class="container wow fadeIn top-buffer">
  <div class="container my-5">
      <div class="row justify-content-center">
          <div class="col-lg-8">
              <b-card title="Set New Password" type="secondary" shadow header-classes="bg-white pb-5" body-classes="px-lg-5 py-lg-5">
                  <b-card-text>
                      <b-form @submit="onSubmit" enctype="multipart/form-data">
                          <b-form-group label="Current Password:" label-for="input-1">
                              <b-form-input type='password' v-model="form.currentPassword" placeholder="Current Password" required>
                              </b-form-input>
                          </b-form-group>
                          <b-form-group label="New Password:" label-for="input-1">
                            <b-form-input  type='password' v-model="form.newPassword" placeholder="New Password" required>
                            </b-form-input>
                        </b-form-group>
                        <b-form-group label="Confirm Password:" label-for="input-1">
                          <b-form-input type='password' v-model="form.confirmPassword" placeholder="Confirm Password" required>
                          </b-form-input>
                      </b-form-group>
                          <b-button type="submit" variant="primary" class="my-4">Set New Password</b-button>
                      </b-form>
                  </b-card-text>
              </b-card>
          </div>
      </div>
  </div>
  <div class="vld-parent">
    <loading :active.sync="isLoading" 
    :can-cancel="false" 
    :is-full-page="true"></loading>
</div>
</div>